export const initialState = {
  notifications: []
};
